import { FC, memo, useCallback } from 'react'
import Dropzone from 'react-dropzone'

import { TableButton } from 'ui/components/Buttons'

import { UploadButtonProps } from './UploadButtonProps'

export const UploadButton: FC<UploadButtonProps> = memo((props) => {
  const { periodId, onFilesAdd, children } = props

  const onFilesAddHandler = useCallback(
    (files: File[]) => {
      onFilesAdd(files, periodId)
    },
    [onFilesAdd, periodId]
  )

  return (
    <Dropzone onDrop={onFilesAddHandler}>
      {({ getRootProps, getInputProps }) => {
        const { ref, ...rootProps } = getRootProps()
        return (
          <span {...rootProps}>
            <input {...getInputProps()} />
            {children || (
              <TableButton innerRef={ref} face="positive">
                Upload
              </TableButton>
            )}
          </span>
        )
      }}
    </Dropzone>
  )
})
